import { Camera } from "lucide-react";
import { useT } from "@/i18n";
import { CAMERAS, PHOTO_TEXT } from "@/components/photo/content";

const COLORS = ["from-yellow-300 to-amber-400", "from-pink-300 to-rose-500", "from-sky-300 to-blue-500", "from-red-300 to-red-500", "from-lime-300 to-green-500", "from-violet-300 to-purple-500"];

export default function Cameras() {
  const { lang } = useT();
  const tx = PHOTO_TEXT[lang];
  return (
    <div>
      <h3 className="font-fredoka text-xl sm:text-2xl font-bold text-blue-950">{tx.cameras}</h3>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CAMERAS.map((c, i) => (
          <div key={c.id} className={`bg-gradient-to-br ${COLORS[i]} rounded-3xl border-4 border-white p-3 shadow-lg`} data-testid={`camera-${c.id}`}>
            <div className="flex items-center justify-between p-2">
              <div className="flex items-center gap-3">
                <div className="bg-white/90 rounded-2xl p-2.5"><Camera className="w-6 h-6 text-blue-950" /></div>
                <div>
                  <p className="font-fredoka text-xl font-bold text-white bubble-text-sm">{c.brand}</p>
                  <p className="text-white font-bold text-sm">{c.model}</p>
                </div>
              </div>
              <span className="bg-white/90 rounded-full px-2.5 py-1 text-xs font-bold text-blue-950">{tx.age} {c.age}</span>
            </div>
            <p className="bg-white/90 rounded-2xl p-3 text-sm font-semibold text-blue-950">{c[lang]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
